import Vue from 'vue';
import Vuex from 'vuex';
import background_processes from "@/servicios/background_processes";
import mutations from './mutation';
import productos from '../servicios/productos';
import hmis from '../servicios/productos/sistemasclasificacion/hmis';
import nacionesunidas from '../servicios/productos/sistemasclasificacion/nacionesunidas';
import nfpa from '../servicios/productos/sistemasclasificacion/nfpa';
import sga from '../servicios/productos/sistemasclasificacion/sga';
import sgacompleto from '../servicios/productos/sistemasclasificacion/sgacompleto';
import autenticacion from '../servicios/autenticacion';
import companyBlockades from '../servicios/empresa/company_blockades';
import empresa from '../servicios/empresa';
import tickets from '../servicios/tickets';
import qr from '../servicios/qr';
import adjuntos from '../servicios/productos/adjuntos';
import etiquetas from '../servicios/productos/etiquetas';
import otrostlv from '../servicios/productos/otrostlv';
import identificacionpeligros from '../servicios/productos/identificacionpeligros';
import epps from '../servicios/productos/epps';
import licencia from '../servicios/licencia';
import productsSearch from '../servicios/productos/productsSearch'
import videos from '../servicios/videos'
// Control de estados para el modulo de empresas (imagen secundaria)
import companySecondaryImage from '../servicios/empresa/secondaryImage/index'
import NuGreCustomFields from '../servicios/administracion/customFields'
import NuGreAdmin from '../servicios/administracion/nuGre'
import NuGreProducts from '../servicios/productos/emergencies/nuGre'

import assignPQTraceable from '../servicios/history/assignPQ'

import sga_et from '../servicios/productos_et/sistemasclasificacion/sga';
import sgacompleto_et from '../servicios/productos_et/sistemasclasificacion/sgacompleto';

import Reporteinventario from '../servicios/reportes/inventario';
import hallazgosSeguimientos from '../servicios/configuracion_auditoria';
import tarjetasEmergencia from '../servicios/productos/tarjetasEmergencia';
import cas from '../servicios/productos/cas';
import pasoapaso from '../servicios/productos/pasoapaso';
//seguimientos hallazgos
import listaChequeo from '../servicios/hallazgos_auditoria';
import hallazgo from '../servicios/configuracion_auditoria/hallazgo';
import seguimiento from '../servicios/configuracion_auditoria/seguimientos';
import itemSeguimiento from '../servicios/configuracion_auditoria/itemSeguimiento';
import tipoListaChequeo from '../servicios/configuracion_auditoria/tipoListaChequeo';
import tipoSeguimiento from '../servicios/configuracion_auditoria/tipoSeguimiento';
import seguimientoHallazgos from '../servicios/seguimiento_hallazgos';
import basesareas from '../servicios/empresa/basesareas';
import asignacionproductos from '../servicios/productos/asignacion';
import documentosEmpresa from '../servicios/empresa/documentos';
import dashboard from '../servicios/dashboard';
import administracion from '../servicios/administracion';
import unifyComponents from '../servicios/administracion/unifyComponents'
import productos_emp from '../servicios/empresa/productos_emp';
import epps_et from '../servicios/productos_et/epps';


import productos_et from '../servicios/productos_et/productos';
import ordenes from '../servicios/productos_et/ordenes';
import adjuntos_et from '../servicios/productos_et/adjuntos_et';
import frases from '../servicios/productos_et/frases';
import etiquetas_et from '../servicios/productos_et/etiquetas';
import pictogram_et from '../servicios/productos_et/productPictogram';
import sga_phrases from '../servicios/productos_et/sga_phrases';


import productos_contra from '../servicios/empresa/contratista';
import planeacionAuditoria from '../servicios/planeacion_auditoria';
import ubicacion from '../servicios/empresa/ubicaciones';
import configTarjetasEmergencia from '../servicios/empresa/tarjetas_emergencia';
import fabricantes from '../servicios/fabricantes';
import matrizCompatibilidad from '../servicios/matrizCompatibilidad';
import matrizCompatibilidadAlmacenamiento from '../servicios/matrizCompatibilidad/almacenamiento';
import registrosAccesos from '../servicios/reportes/registrosAccesos';

import propiedades from '../servicios/productos/propiedades';
import tareas from '../servicios/risk_analysis/analysis';
import tasks from '../servicios/risk_analysis/tasks';
import hygienic_measurements from '../servicios/risk_analysis/hygienic_measurements';
import analysis from '../servicios/risk_analysis/analysis';
import control_sheets_analysis from '../servicios/risk_analysis/analysis/control_sheets';
import control_sheets from '../servicios/risk_analysis/control_sheets';
import home from '../servicios/empresa/home';
import banners from '../servicios/banners';
import config_concepts from '../servicios/risk_analysis/config_concepts';

import accidentesMayores from '../servicios/accidentesMayores';
import licencias from '../servicios/empresa/licencias';

import location from '../servicios/empresa/locations';
// fds
import fds_empresa from '../servicios/fds/empresa';
import rolesPermissions from '../servicios/roles_permissions';
import fds_productos from '../servicios/fds/productos';
import binputum from '../servicios/fds/binputum';
import identification_hazard from '../servicios/identification_hazard/matrix_ram';
import matrix_hazid from '../servicios/identification_hazard/matrix_hazid';

//productos empresas
import assignment from '../servicios/productos/assignment';

//Nuevo CAS
import nuevocas from '../servicios/productos/nuevoCas';

/**
 * Calculadora
 */
import productsCalculator from '../servicios/calculator/products';

//inventory
import sections from '../servicios/inventory/sections';
import colums from '../servicios/inventory/colums';
import inventoryTypes from '../servicios/inventory/inventoryTypes';


//Análisis de riesgo
import areas from '../servicios/workers/areas';
import wor_epps from '../servicios/workers/epps';
import workers from '../servicios/workers/workers';
import positions from '../servicios/workers/positions';
import trainings from '../servicios/workers/trainings';
import training_companies from '../servicios/workers/training_companies';

//nuevo accidentes mayores
import accidents_high from '../servicios/accidents_high';
import admin_accidents_high from '../servicios/accidents_high/admin';
import providers from '../servicios/providers';

import productsProviders from '../servicios/products_providers'
import process_security from '../servicios/process_security'

// Variables configurables
import configurableVariables from '../servicios/empresa/configurableVariables'

// Listas
import sysList from '../servicios/sysList'

// Países
import countries from '../servicios/countries'

// Servicios (mutaciones / estados / acciones) para los pagos de las licencias.
import monthlyPayments from '../servicios/empresa/licencias/monthly-payments';
import general_monitoring from '../servicios/general_monitoring';

import enterprises from '../servicios/enterprises';
import groups from '../servicios/groups';
import businesses from '../servicios/businesses';

import decret_1630 from '../servicios/decret_1630'

// Ver detalles del producto mediante la url del qr.
import visualizer from '../servicios/productos/visualizer/index'

// Interceptor de URLs cortar para redireccionar a las URLs largas.
import urlsShorter from '../servicios/urlsShorter/index'

// Control de estados para el módulo de Señalización de tanques en Emergencias.
import signalingOfTanks from '../servicios/productos/emergencies/SignalingOfTanks/index'

// Control de estados para el módulo de Señalización de tanques en en Reportes.
import signalingOfTanksReports from '../servicios/reportes/SignalingOfTanks/index'

// Control de estados para el Filtro del módulo de Señalización de tanques en en Reportes.
import filterSignalingOfTanksReports from '../servicios/reportes/SignalingOfTanks/Filter/index'

import appBanners from '../servicios/app_banners'

// Historial de productos
import updatePQ from '../servicios/history/updatePQ'

import findings from '../servicios/findings'
import casFamily from "@/servicios/productos/casFamily";
// Gráficas generales
import control_panel from '../servicios/control_panel'

// Nuevo SGA 2
import sgaVersions from '../servicios/sga/configurations/versions'
import sgaTypesOfDangers from '../servicios/sga/configurations/typesOfDangers'
import sgaCategories from '../servicios/sga/configurations/categories'
import sgaSubCategories from '../servicios/sga/configurations/subCategories'
import sgaPictograms from '../servicios/sga/configurations/pictograms'
import sgaLanguages from '../servicios/sga/configurations/languages'
import sgaWordsOfCaution from '../servicios/sga/configurations/wordsOfCaution'
import sgaIndicationsOfDanger from '../servicios/sga/configurations/indicationsOfDanger'
import sgaTypesTipPrudence from '../servicios/sga/configurations/typesTipPrudence'
import sgaTipsPrudence from '../servicios/sga/configurations/tipsPrudence'
import sgaTypesSubCategories from '../servicios/sga/configurations/typesSubCategories'
import sgaRulesPictograms from '../servicios/sga/configurations/pictograms/rules'
import sgaRulesTipsPrudence from '../servicios/sga/configurations/tipsPrudence/rules'
import sgaRulesIndicationsOfDanger from '../servicios/sga/configurations/indicationsOfDanger/rules'

// Nuevo SGA 2 - productos
import productSga2subCategories from '../servicios/productos/classificationSystem/sga2/subCategories';
import productSga2 from '../servicios/productos/classificationSystem/sga2';
import productSga2pictograms from '../servicios/productos/classificationSystem/sga2/pictograms';
import productSga2subsNotDangers from '../servicios/productos/classificationSystem/sga2/subsNotDangers';
import productSga2DangersIndications from '../servicios/productos/classificationSystem/sga2/dangersIndications';
import productSga2TipsPrudence from '../servicios/productos/classificationSystem/sga2/tipsPrudence';
import productSga2WordsOfCaution from '../servicios/productos/classificationSystem/sga2/wordsOfCaution';
import productSga2ConfigLabels from '../servicios/productos/classificationSystem/sga2/configLabels';

// Roles de trabajadores
import rolesWorker from '../servicios/workers/roles'

// Locaciones de empresas
import sites from '../servicios/empresa/sites'

//Forms
import formBuilder from '../servicios/form_builder'
// Idiomas
import languages from '../servicios/languages'

Vue.use(Vuex);

//=======vuex store start===========
const store = new Vuex.Store({
    state: {
        permisos: '',
        roles: '',
        loading: false

    },
    mutations,
    modules: {
        productos,
        hmis,
        nacionesunidas,
        nfpa,
        sga,

        productSga2,
        productSga2subCategories,
        productSga2subsNotDangers,
        productSga2pictograms,
        productSga2DangersIndications,
        productSga2TipsPrudence,
        productSga2WordsOfCaution,
        productSga2ConfigLabels,

        sgacompleto,
        autenticacion,
        companyBlockades,
        empresa,
        tickets,
        qr,
        adjuntos,
        etiquetas,
        otrostlv,
        identificacionpeligros,
        epps,
        licencia,
        productos_et,
        ordenes,
        hallazgosSeguimientos,
        tarjetasEmergencia,
        Reporteinventario,
        cas,
        listaChequeo,
        hallazgo,
        sga_et,
        sgacompleto_et,
        seguimiento,
        basesareas,
        asignacionproductos,
        dashboard,
        productsSearch,
        itemSeguimiento,
        tipoListaChequeo,
        tipoSeguimiento,
        documentosEmpresa,
        administracion,
        unifyComponents,
        productos_emp,
        epps_et,
        adjuntos_et,
        frases,
        etiquetas_et,
        productos_contra,
        planeacionAuditoria,
        ubicacion,
        configTarjetasEmergencia,
        fabricantes,
        pasoapaso,
        matrizCompatibilidad,
        matrizCompatibilidadAlmacenamiento,
        propiedades,
        tareas,
        tasks,
        hygienic_measurements,
        analysis,
        config_concepts,
        registrosAccesos,
        control_sheets_analysis,
        control_sheets,
        accidentesMayores,
        home,
        banners,
        seguimientoHallazgos,
        licencias,
        location,
        fds_empresa,
        fds_productos,
        binputum,
        identification_hazard,
        assignment,
        nuevocas,
        rolesPermissions,
        matrix_hazid,
        videos,
        //Calculadora
        productsCalculator,

        assignPQTraceable,

        //new inventory
        sections,
        colums,
        inventoryTypes,
        pictogram_et,
        sga_phrases,

        //análisis de riesgos
        areas,
        wor_epps,
        workers,
        positions,
        trainings,
        training_companies,
        //nuevo accidentes mayores
        accidents_high,
        admin_accidents_high,
        providers,
        productsProviders,
        process_security,

        // Variables configurables
        configurableVariables,

        // Listas
        sysList,

        // Países
        countries,

        // Control de estados para el modulo de empresas (imagen secundaria)
        companySecondaryImage,
        NuGreCustomFields,
        NuGreAdmin,
        NuGreProducts,

        // Pagos de las licencias.
        monthlyPayments,
        general_monitoring,
        enterprises,
        groups,
        businesses,
        decret_1630,

        // Ver detalles del producto mediante la url del qr.
        visualizer,

        // Interceptor de URLs cortar para redireccionar a las URLs largas.
        urlsShorter,

        // Control de estados para el módulo de Señalización de tanques en Emergencias.
        signalingOfTanks,
        background_processes,
        // Control de estados para el módulo de Señalización de tanques en en Reportes.
        signalingOfTanksReports,

        // Control de estados para el Filtro del módulo de Señalización de tanques en en Reportes.
        filterSignalingOfTanksReports,
        appBanners,

        // Historial de productos
        updatePQ,
        casFamily,
        findings,
        control_panel,

        // Nuevo SGA
        sgaVersions,
        sgaTypesOfDangers,
        sgaCategories,
        sgaSubCategories,
        sgaPictograms,
        sgaLanguages,
        sgaWordsOfCaution,
        sgaIndicationsOfDanger,
        sgaTypesTipPrudence,
        sgaTipsPrudence,
        sgaTypesSubCategories,
        sgaRulesPictograms,
        sgaRulesTipsPrudence,
        sgaRulesIndicationsOfDanger,

        // Roles de trabajadores
        rolesWorker,

        // Locaciones de empresas
        sites,

        //Forms
        formBuilder,
        languages
    }
});

store.$vue = new Vue();

//=======vuex store end===========
export default store;
